import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router';
import { useCallback, useMemo, useRef, useState } from 'react';

import { Checkbox, JuicyTypography } from '../../components/index.ts';
import { Keyboard } from '../../features/index.ts';
import { PhoneInput, type PhoneInputHandle, type PhoneInputMeta } from '../../components/index.ts';
import { PageBackButton } from '../../components/button/pageBackButton.tsx';
import { NextPageButton } from '../../components/button/NextPageButton.tsx';
import { Path } from '../../assets/enums/index.ts';

import type { MuiTelInputCountry } from 'mui-tel-input';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';

export const PhonePage = () => {
  const nav = useNavigate();
  const { setParams } = useGameSessionContext();

  const phoneRef = useRef<PhoneInputHandle | null>(null);

  const [isTermsAccepted, setIsTermsAccepter] = useState<boolean>(false);

  const [country, setCountry] = useState<MuiTelInputCountry>('AU');
  const [nationalDigits, setNationalDigits] = useState<string>('');

  const [phoneValue, setPhoneValue] = useState<string>('');
  const [maxNationalDigits, setMaxNationalDigits] = useState<number>(15);

  const handleMetaChange = useCallback((meta: PhoneInputMeta) => {
    setPhoneValue(meta.phoneValue);
    setMaxNationalDigits(meta.maxNationalDigits);
  }, []);

  const onNextPageButtonClick = useCallback(() => {
    setParams({ phoneNumber: phoneValue });
    nav(Path.PhoneConfirmation);
  }, [setParams, phoneValue, nav]);

  const isNextPageButtonDisabled = useMemo(() => {
    return !isTermsAccepted || nationalDigits.length < maxNationalDigits;
  }, [isTermsAccepted, nationalDigits, maxNationalDigits]);

  return (
    <Stack height={'100%'} pb={14} pt={20}>
      <JuicyTypography mb={30}>Just some final details before getting started</JuicyTypography>

      <PhoneInput
        ref={phoneRef}
        country={country}
        nationalDigits={nationalDigits}
        onCountryChange={setCountry}
        onNationalDigitsChange={setNationalDigits}
        onMetaChange={handleMetaChange}
      />

      <Box mt={14}>
        <Checkbox
          value={isTermsAccepted}
          onChange={(e) => setIsTermsAccepter(e.currentTarget.checked)}
          label={'I accept Moneyball’s Terms & Conditions'}
        />
      </Box>

      <Keyboard
        mt="auto"
        onKeyClick={(d) => phoneRef.current?.onKeyClick(d)}
        onClearButtonClick={() => phoneRef.current?.onClear()}
      />

      <Stack width="100%" direction={'row'} alignItems={'center'} gap={8} mt={20}>
        <PageBackButton onClick={() => nav(Path.GameSettings)} />
        <NextPageButton disabled={isNextPageButtonDisabled} onClick={onNextPageButtonClick}>
          Continue
        </NextPageButton>
      </Stack>
    </Stack>
  );
};
